<template>
  <div class="relative w-full max-h-12">
    <h6
      class="absolute max-w-full px-1 text-xs font-semibold text-theme-secondary left-4 -top-2 truncate backdrop-blur-sm"
    >
      {{ $t('Where') }}
    </h6>
    <select
      :placeholder="$t('Select..')"
      class="block w-full py-2.5 h-10 pl-12 overflow-hidden text-xs border rounded-lg outline-none focus:ring-0 ring-0 text-theme-primary placeholder:text-theme-primary max-h-12 dark:bg-transparent border-theme-divider"
      v-model="selectedRegion"
      v-bind="$attrs"
    >
      <option value="" selected>{{ $t('Select city or a region') }}</option>
      <option v-for="(option, index) in options" :value="index" :key="index">{{ option }}</option>
    </select>
    <svg
      class="absolute -translate-y-1/2 pointer-events-none left-4 top-1/2"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="21"
      viewBox="0 0 18 21"
      fill="none"
    >
      <path
        d="M9 0C11.3869 0 13.6761 0.948211 15.364 2.63604C17.0518 4.32387 18 6.61305 18 9C18 12.074 16.324 14.59 14.558 16.395C13.6755 17.2869 12.7128 18.0956 11.682 18.811L11.256 19.101L11.056 19.234L10.679 19.474L10.343 19.679L9.927 19.921C9.64451 20.0818 9.32505 20.1663 9 20.1663C8.67495 20.1663 8.35549 20.0818 8.073 19.921L7.657 19.679L7.137 19.359L6.945 19.234L6.535 18.961C5.42298 18.2083 4.38707 17.3489 3.442 16.395C1.676 14.588 0 12.074 0 9C0 6.61305 0.948211 4.32387 2.63604 2.63604C4.32387 0.948211 6.61305 0 9 0ZM9 6C8.60603 6 8.21593 6.0776 7.85195 6.22836C7.48797 6.37913 7.15726 6.6001 6.87868 6.87868C6.6001 7.15726 6.37913 7.48797 6.22836 7.85195C6.0776 8.21593 6 8.60603 6 9C6 9.39397 6.0776 9.78407 6.22836 10.1481C6.37913 10.512 6.6001 10.8427 6.87868 11.1213C7.15726 11.3999 7.48797 11.6209 7.85195 11.7716C8.21593 11.9224 8.60603 12 9 12C9.79565 12 10.5587 11.6839 11.1213 11.1213C11.6839 10.5587 12 9.79565 12 9C12 8.20435 11.6839 7.44129 11.1213 6.87868C10.5587 6.31607 9.79565 6 9 6Z"
        class="fill-theme-disabled"
      />
    </svg>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { fetchReferenceData } from '@/Composables/use-reference-data/useReferenceData';

defineOptions({
  inheritAttrs: false,
});

const props = defineProps({
  route: String,
  regValue: {
    type: String,
    default: '',
  },
});

const selectedRegion = defineModel({ type: String, default: '' });
const options = ref();

const getList = async () => {
  try {
    options.value = await fetchReferenceData(props.route);
  } catch (error) {
    console.error('Error fetching region data:', error);
  }
};

onMounted(() => {
  if (!selectedRegion.value && props.regValue) {
    selectedRegion.value = props.regValue;
  }

  getList();
});
</script>
<style>
.border {
  border-color: var(--color-divider);
}
</style>
